exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card--section--title--edit{text-align:right;margin-top:10px}.guest--card--edit--vselect{padding-right:0!important;border-right:1px solid #ececec!important}.guest--card--edit--vselect .open-indicator{right:23px}.toogle-pet svg{left:6px}.disclaimer{font-family:PT Sans Narrow,sans-serif;font-size:13px;color:#6f8695}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-65ff6d44","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/person/guest-cards/GuestCardDetails.vue
// module id = DCKm
// module chunks = 0 1